<template>
  <v-container>
    <v-btn color="cyan" class="white--text" @click="addItem">
      <v-icon color="white">add</v-icon>追加
    </v-btn>
    <v-dialog v-model="dialog" max-width="80%">
      <edit-item
        v-if="dialog"
        @closeDialog="closeDialog"
        @createItem="createItem"
        @updateItem="updateItem"
        v-model="selectedItem"
        :action="action"
        :schedule-dictionary="scheduleDictionary"
      />
      <v-alert :value="errorMessage.length>0">{{errorMessage}}</v-alert>
    </v-dialog>
    <loading :isLoading="isLoading"/>
    <v-data-table :headers="headers" :items="items" class="elevation-1" rows-per-page-text="表示行" :pagination.sync="pagination">
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.item.subject}}</td>
          <td>{{props.item.to}}</td>
          <td>{{props.item.toStatus}}</td>
          <td>{{props.item.datetime}}</td>
          <td>{{props.item.status}}</td>
          <td>
            <v-btn icon @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="props"
      >{{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示</template>
    </v-data-table>
  </v-container>
</template>
<script>
import db from "@/components/firebaseInit";
import EditItem from "@/components/manage_survey/edit_auto_mail.vue";
import Loading from "@/components/loading.vue";
import firebase from "firebase";
import { mapActions } from "vuex";
import { parse } from "path";

const newItem = {
  body: "",
  datetime: "",
  status: "未送信",
  subject: "",
  to: "",
  toStatus: "全て"
};
export default {
  components: { EditItem, Loading },
  props: {
    scheduleDictionary:{
      type:Array,
      required:true
    }
  },
  data() {
    return {
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("auto_mails"),
      items: [],
      headers: [
        { text: "件名", value: "subject", sortable: false },
        { text: "送信先", value: "to", sortable: false },
        { text: "送信先ステータス", value: "toStatus", sortable: false },
        { text: "送信日時", value: "datetime", sortable: false },
        { text: "ステータス", value: "status", sortable: false },
        { text: "操作", sortable: false }
      ],
      dialog: false,
      selectedEmail: {},
      users: {},
      usersArray: [],
      errorMessage: "",
      isLoading: false,
      pagination: {
        rowsPerPage: 50
      },
    };
  },
  mounted() {
    this.reloadItems();
  },
  created() {},
  methods: {
    async reloadItems() {
      this.isLoading = true;
      this.items = [];
      const items = await this.dbRef.get();
      items.forEach(doc => {
        this.items.push({ ...doc.data(), id: doc.id });
      }, this);
      this.isLoading = false;
    },
    closeDialog() {
      this.errorMessage = "";
      this.dialog = false;
    },
    async createItem() {
      try {
        await this.dbRef.add(this.selectedItem);
        this.closeDialog();
        this.reloadItems();
      } catch (e) {
        //this.errorMessage = authErrorCodeToMessage(e.code)
        console.log(e);
      }
    },
    editItem(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.action = "update";
      this.dialog = true;
    },
    addItem() {
      this.selectedItem = JSON.parse(JSON.stringify(newItem));
      this.action = "add";
      this.dialog = true;
    },
    async deleteItem(item) {
      try {
        await this.dbRef.doc(item.id).delete();
        this.reloadItems();
      } catch (e) {
        console.log(e);
      }
    },
    async updateItem(isWritingMails) {
      await this.dbRef.doc(this.selectedItem.id).set(this.selectedItem);
      this.closeDialog();
      this.reloadItems();
    },
    writingMails() {
      toAdresses = [];
      sendDatetime = 0;
      subject = "";
      body = "";
    },
    getAdresses() {},
    replaceFieldsWithText() {}
  }
};
</script>